import * as S from "./styled";

function Footer() {
  return (
    <S.Container>
      <S.Link
        href="https://www.linkedin.com/in/hebertmontarroyos-developer/"
        target="_blank"
      >
        © Desenvolvido por Hebert Montarroyos
      </S.Link>
    </S.Container>
  );
}

export default Footer;
